import { useDefineProviderRoute } from "@versatile-credit-apply/composition"
import { type RouteRecordRaw } from "vue-router"
import {
  ScreenId,
  type StaticProviderKey,
} from "@versatile-credit-apply/omni-apply-client"

const providerKey: StaticProviderKey = "claritypay_standard"
const { defineRoute } = useDefineProviderRoute(providerKey)

export const routes: RouteRecordRaw[] = [
  defineRoute({
    name: "claritypay.decision.prequalified",
    path: "/apply/:applyStage/responses/prequalified",
    inherit: true,
    component: () => import("@/views/apply/ExploreOffersView.vue"),
    meta: {
      screenId: ScreenId.OFFER_PRESENTATION_PREQUAL,
    },
  }),
  defineRoute({
    name: "claritypay.review-offer",
    path: "/apply/:applyStage/:planCode/review",
    component: () => import("./views/ClarityPayReviewOfferView.vue"),
    props: true,
    meta: {
      step: "decision",
    },
  }),
  defineRoute({
    path: "/apply/:applyStage/responses/pending/reason/esign",
    inherit: true,
    component: () =>
      import("@/providers/claritypay_standard/views/ClarityPayPendingEsignView.vue"),
    meta: {
      step: "decision",
    },
  }),
  defineRoute({
    path: "/apply/:applyStage/complete",
    inherit: true,
    component: () =>
      import("@/providers/claritypay_standard/views/ClarityPayOfferCompleteView.vue"),
    meta: {
      step: "decision",
    },
  }),
  defineRoute({
    path: "/apply/:applyStage/error",
    inherit: true,
    component: () =>
      import("@/providers/claritypay_standard/views/ClarityPayErrorView.vue"),
    meta: {
      step: "decision",
    },
  }),
]
